import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import { getToken, getCallUrl } from '@/utils/auth.js'
import { platformUrl } from '@/api/api'
import variable from '@/utils/variable'
import axios from 'axios'
Vue.use(Router)
const routes = [
    {
        path: '/',
        redirect: '/home',
    },

    // {
    //     path:'/home',
    //     meta: { access: 'home', title: '首页' },
    //     component: () => import('@/views/home/index')
    // },

    // 首页
    {
        path: '/home',
        name: 'dashbord',
        redirect: '/home/index',
        meta: { access: 'home', title: '首页' },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'home',
                meta: { access: 'home', title: '首页' },
                component: () => import('@/views/home/index'),
            },
            {
                path: 'detail',
                name: 'homeDetail',
                meta: { access: 'home', title: '平台介绍详情' },
                component: () => import('@/views/home/detail'),
            },
            {
                path: 'pass',
                name: 'homePass',
                meta: { access: 'home', title: '平台介绍详情' },
                component: () => import('@/views/home/pass'),
            },
        ]
    },
    // paas
    {
        path: '/paas',
        name: 'paas',
        redirect: '/paas/index',
        meta: { access: 'paas', title: 'paas' },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'paas',
                meta: { access: 'paas', title: 'paas' },
                component: () => import('@/views/paas/index'),
            },
        ]
    },
    // 关于卫龙
    {
        path: '/platform',
        name: 'platform',
        redirect: '/platform/about',
        meta: { access: 'manage', title: '关于卫龙' },
        component: Layout,
        children: [
            {
                path: 'about',
                name: 'about',
                meta: { access: 'platform', title: '关于卫龙' },
                component: () => import('@/views/platform/about/index'),
            },
            {
                path: 'information',
                name: 'information',
                meta: { access: 'information', title: '行业资讯' },
                component: () => import('@/views/platform/information/index'),
            },
            {
                path: 'arcitle',
                name: 'arcitle',
                meta: { access: 'information', title: '资讯详情' },
                component: () => import('@/views/platform/information/arcitle'),
            }
        ]
    },
    // 平台服务
    {
        path: '/serve',
        name: 'serve',
        redirect: '/serve/lowCode',
        meta: { access: 'serve', title: '平台服务' },
        component: Layout,
        children: [
            {
                path: 'lowCode',
                name: 'lowCode',
                meta: { access: 'serve', title: 'MCC·低代码平台' },
                component: () => import('@/views/serve/lowCode'),
            },
            {
                path: 'openWeb',
                name: 'openWeb',
                meta: { access: 'serve', title: 'MCC·开放平台' },
                component: () => import('@/views/serve/openWeb'),
            },
            {
                path: 'coderCenter',
                name: 'coderCenter',
                meta: { access: 'serve', title: 'MCC·开发者中心' },
                component: () => import('@/views/serve/coderCenter'),
            },
            {
                path: 'dataService',
                name: 'dataService',
                meta: { access: 'serve', title: 'MCC·数据服务' },
                component: () => import('@/views/serve/dataService'),
            }
        ]
    },
    // 边缘层
    {
        path: '/edge',
        name: 'edge',
        redirect: '/edge/scheme',
        meta: { access: 'edge', title: '边缘层' },
        component: Layout,
        children: [
            {
                path: 'equipment',
                name: 'equipment',
                meta: { access: 'edge', title: '设备详情' },
                component: () => import('@/views/edge/equipment'),
            },
            {
                path: 'scheme',
                name: 'scheme',
                meta: { access: 'edge', title: '接入方案' },
                component: () => import('@/views/edge/scheme'),
            },
        ]
    },
    // 固废云
    {
        path: '/wasteCloud',
        name: 'wasteCloud',
        redirect: '/wasteCloud/index',
        meta: { access: 'wasteCloud', title: '钢构云' },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'cloud',
                meta: { access: 'wasteCloud', title: '钢构云' },
                component: () => import('@/views/wasteCloud/index'),
            },
        ]
    },
    // 供需对接
    {
        path: '/demand',
        name: 'demand',
        redirect: '/demand/index',
        meta: { access: 'demand', title: '供需对接' },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'demandCloud',
                meta: { access: 'demand', title: '供需对接' },
                component: () => import('@/views/demand/index'),
            },
        ]
    },
    // 根据code获取token的页面
    {
        path: '/auth',
        component: () => import('@/views/auth/index.vue'),
        meta: { access: 'demand', title: '验证' },
        hidden: true
    },

     // 应用中心
     {
        path: '/applyCenter',
        name: 'apply',
        redirect: '/applyCenter/index',
        meta: { access: 'applyCenter', title: '应用中心' },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'applyCenter',
                meta: { access: 'applyCenter', title: '应用中心' },
                component: () => import('@/views/applyCenter/index'),
            },
        ]
    },
    // 解决方案
    {
        path: '/solution',
        name: 'solut',
        redirect: '/solution/index',
        meta: { access: 'solution', title: '解决方案' },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'solution',
                meta: { access: 'solution', title: '解决方案' },
                component: () => import('@/views/solution/index'),
            },
            {
                path: 'detail',
                name: 'solutDetail',
                meta: { access: 'solution', title: '解决方案详情' },
                component: () => import('@/views/solution/detail'),
            },
        ]
    },
    // 工业品发布
    {
        path: '/productRelease',
        name: 'product',
        redirect: '/productRelease/index',
        meta: { access: 'productRelease', title: '工业品发布' },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'productRelease',
                meta: { access: 'productRelease', title: '工业品发布' },
                component: () => import('@/views/productRelease/index'),
            },
            {
                path: 'detail',
                name: 'productDetail',
                meta: { access: 'productRelease', title: '工业品发布详情' },
                component: () => import('@/views/productRelease/detail'),
            },
        ]
    },
     // 应用市场
     {
        path: '/applyWeb',
        name: 'applyWeb',
        redirect: '/applyWeb/index',
        meta: { access: 'applyWeb', title: '应用市场' },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'applyStore',
                meta: { access: 'applyWeb', title: '应用市场' },
                component: () => import('@/views/applyWeb/index'),
            },
        ]
    },
    // 开发者社区
    {
        path: '/developer',
        name: 'developerWeb',
        redirect: '/developer/index',
        meta: { access: 'developer', title: '开发者社区' },
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'developer',
                meta: { access: 'developer', title: '开发者社区' },
                component: () => import('@/views/developer/index'),
            },
        ]
    },
]

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: routes
})

const router = createRouter()
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
// 需要登录的页面
// const loginPage = ['/manage','/editPwd']
const loginPage = ['/controlBoard/apply']
router.beforeEach(async (to, from, next) => {

      // 系统访问记录
		let toObj = {}
		if(to.path.indexOf('/redirect') == -1){
			toObj = {
				path:to.path,
				name:to.meta.title?to.meta.title:''
			}
			// console.log('toObj',toObj)
		}
        let identify = variable.identify
        if(toObj.path && toObj.name){
            let data = {
                identify,
                path:toObj.path,
                menu:toObj.name
            }
            axios.post('/user/devOpsAccessRecord/save', data)
              .then(function (res) {
                // console.log('res',res);
              })
              .catch(function (error) {
                // console.log(error);
              })  
        }

    const hasToken = getToken()
    document.title = to.meta.title + '-卫龙辣味食品制造云工业互联网平台'
    if (hasToken) {
        // 已登录
        if (to.path === '/login') {
            // 如果去登录页，跳转至首页
            next({ path: '/' })
        } else {
            next()
        }
    } else {
        if (loginPage.indexOf(to.path) !== -1) {
            // 需要登录的页面，去登录页面
			// window.location.href = platformUrl + '/login.html'
            getCallUrl()

        } else {
            next()
        }
    }
})

export default router